import { ServiceConfig } from 'angular-odata';

//#region ODataApi Imports
//#endregion

export const SortimenteServiceConfig = {
  name: "Sortimente",
  annotations: []
} as ServiceConfig;